<template>
  <section :class="regionClass" aria-live="polite" aria-relevant="additions removals">
    <article
      v-for="toast in toasts"
      :key="toast.id"
      :class="[toastClass, `${toastToneClassPrefix}-${toast.tone}`]"
      role="status"
    >
      <span v-if="showIcon" :class="iconClass" aria-hidden="true">{{
        iconForTone(toast.tone)
      }}</span>
      <span>{{ toast.message }}</span>
      <button
        :class="closeButtonClass"
        type="button"
        :aria-label="dismissAriaLabel"
        @click="$emit('dismiss', toast.id)"
      >
        {{ dismissLabel }}
      </button>
    </article>
  </section>
</template>

<script setup lang="ts">
import type { PriceRescueToastItem, PriceRescueToastTone } from "../types/tones.js";

withDefaults(
  defineProps<{
    closeButtonClass?: string;
    dismissAriaLabel?: string;
    dismissLabel?: string;
    iconClass?: string;
    regionClass?: string;
    showIcon?: boolean;
    toastClass?: string;
    toastToneClassPrefix?: string;
    toasts: PriceRescueToastItem[];
  }>(),
  {
    closeButtonClass: "price-rescue-toast__close",
    dismissAriaLabel: "Dismiss notification",
    dismissLabel: "Dismiss",
    iconClass: "price-rescue-toast__icon",
    regionClass: "price-rescue-toast-region",
    showIcon: true,
    toastClass: "price-rescue-toast",
    toastToneClassPrefix: "price-rescue-toast",
  },
);

defineEmits<{
  dismiss: [id: string];
}>();

function iconForTone(tone: PriceRescueToastTone): string {
  if (tone === "success") return "OK";
  if (tone === "warning") return "!";
  if (tone === "error") return "X";
  return "i";
}
</script>
